import {
    calculatorBreadcrumb,
    calculators,
    calculatorSlugs,
} from '@components/Calculators/helpers/constants';
import { theme } from '@ui/tailwind.config';
import {
    carLoanCalculatorDefaultValues,
    homeLoanCalculatorDefaultValues,
    loanCalculatorTypes,
    personalLoanCalculatorDefaultValues,
} from '@components/Calculators/LoanEmi/helper';
import { sipCalculatorDefaultValues } from '@components/Calculators/sip/helper';
import {
    financialGoalCorpusDefaultValues,
    financialGoalCorpusType,
} from 'components/Calculators/FinancialGoalCorpus/helper';
import { fdCalculatorDefaultValues } from '@components/Calculators/fd/helper';

export const getOtherCalculators = (route) => {
    return calculators.filter((calculator) => calculator.link !== route);
};

export const getCalculatorBreadcrumb = (activeCalculator) => {
    return [
        ...calculatorBreadcrumb,
        {
            title: activeCalculator,
            active: true,
        },
    ];
};

export const getPieChartFallback = () => {
    return [{ name: 'No Data', value: 1, color: theme.colors.primary?.[70] }];
};

export const getCalculatorsDefaultValues = (slug) => {
    switch (slug) {
        case calculatorSlugs.SIP_CALCULATOR:
            return sipCalculatorDefaultValues;
        case calculatorSlugs.PERSONAL_LOAN_EMI_CALCULATOR:
            return personalLoanCalculatorDefaultValues;
        case calculatorSlugs.HOME_LOAN_EMI_CALCULATOR:
            return homeLoanCalculatorDefaultValues;
        case calculatorSlugs.CAR_LOAN_EMI_CALCULATOR:
            return carLoanCalculatorDefaultValues;
        case calculatorSlugs.MARRIAGE_CORPUS_CALCULATOR:
        case calculatorSlugs.EDUCATION_CORPUS_CALCULATOR:
            return financialGoalCorpusDefaultValues;
        case calculatorSlugs.FD_CALCULATOR:
            return fdCalculatorDefaultValues;
        default:
            break;
    }
};

export const getCalculatorsType = (slug) => {
    switch (slug) {
        case calculatorSlugs.PERSONAL_LOAN_EMI_CALCULATOR:
            return loanCalculatorTypes.PERSONAL_LOAN;
        case calculatorSlugs.HOME_LOAN_EMI_CALCULATOR:
            return loanCalculatorTypes.HOME_LOAN;
        case calculatorSlugs.CAR_LOAN_EMI_CALCULATOR:
            return loanCalculatorTypes.CAR_LOAN;
        case calculatorSlugs.MARRIAGE_CORPUS_CALCULATOR:
            return financialGoalCorpusType.MARRIAGE_CORPUS;
        case calculatorSlugs.EDUCATION_CORPUS_CALCULATOR:
            return financialGoalCorpusType.EDUCATION_CORPUS;
        default:
            break;
    }
};

const sipCalculatorHeadTagData = {
    title: `SIP Calculator: Calculate your SIP Investment Returns Online`,
    metaDesc: `Estimate returns on your SIP investments with ease. Use our SIP calculator to plan and achieve your financial goals today!`,
};

const personalLoanCalculatorHeadTagData = {
    title: `Personal Loan EMI Calculator: Plan your Monthly Repayments`,
    metaDesc: `Calculate your personal loan EMI quickly and easily. Plan monthly repayments and budget effectively with our free tool.`,
};

const carLoanCalculatorHeadTagData = {
    title: `Car Loan EMI Calculator: Estimate your Monthly Payments`,
    metaDesc: `Quickly calculate your car loan EMI with our easy-to-use calculator. Plan your finances and make informed decisions for your car loan.`,
};

const homeLoanCalculatorHeadTagData = {
    title: `Home Loan EMI Calculator: Calculate your Housing Loan EMIs`,
    metaDesc: `Estimate your home loan EMI with precision. Plan your home purchase with confidence using our free calculator.`,
};

const marriageCorpusCalculatorHeadTagData = {
    title: `Marriage Calculator: Estimate the Investment Corpus Required`,
    metaDesc: `Calculate the investment corpus needed for a wedding. Use our marriage calculator to estimate the investment corpus you need for a dream wedding.`,
};

const educationCorpusCalculatorHeadTagData = {
    title: `Child's Education Calculator: Plan Future Education Costs`,
    metaDesc: `Secure your child’s future by planning education expenses with our corpus calculator. Start your savings plan today!`,
};

export const getCalculatorsHeadTagData = (slug) => {
    switch (slug) {
        case calculatorSlugs.SIP_CALCULATOR:
            return sipCalculatorHeadTagData;
        case calculatorSlugs.PERSONAL_LOAN_EMI_CALCULATOR:
            return personalLoanCalculatorHeadTagData;
        case calculatorSlugs.HOME_LOAN_EMI_CALCULATOR:
            return homeLoanCalculatorHeadTagData;
        case calculatorSlugs.CAR_LOAN_EMI_CALCULATOR:
            return carLoanCalculatorHeadTagData;
        case calculatorSlugs.MARRIAGE_CORPUS_CALCULATOR:
            return marriageCorpusCalculatorHeadTagData;
        case calculatorSlugs.EDUCATION_CORPUS_CALCULATOR:
            return educationCorpusCalculatorHeadTagData;
        default:
            break;
    }
};
